import { render, staticRenderFns } from "./biodata.vue?vue&type=template&id=31e1a22f"
import script from "./biodata.vue?vue&type=script&lang=js"
export * from "./biodata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports